var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters.isEcosystem)?_c('ecosystem-enterprises'):_vm._e(),(_vm.$store.getters.isStartup)?_c('startup-enterprises'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }